<div
  id="pcoded"
  class="pcoded"
  [ngClass]="animateSidebar"
  [attr.nav-type]="navType"
  [attr.theme-layout]="themeLayout"
  [attr.horizontal-placement]="verticalPlacement"
  [attr.horizontal-layout]="verticalLayout"
  [attr.pcoded-device-type]="pcodedDeviceType"
  [attr.vertical-nav-type]="verticalNavType"
  [attr.vertical-effect]="verticalEffect"
  [attr.hnavigation-view]="vnavigationView"
  [attr.fream-type]="freamType"
  [attr.sidebar-img]="sidebarImg"
  [attr.sidebar-img-type]="sidebarImgType"
  [attr.layout-type]="layoutType"
  (window:resize)="onResize($event)"
>
  <!--<div class="pcoded-overlay-box"></div>-->
  <div class="pcoded-container navbar-wrapper">
    <nav
      class="navbar header-navbar pcoded-header"
      [attr.header-theme]="headerTheme"
      [attr.pcoded-header-position]="pcodedHeaderPosition"
    >
      <div class="navbar-wrapper">
        <div class="navbar-logo">
          <div [hidden]="hideNavMenu">
            <a
              class="mobile-menu ripple light nav-list"
              id="mobile-collapse"
              href="javascript:"
              (click)="toggleOpened($event)"
            >
              <i class="feather" [ngClass]="toggleIcon"></i>
            </a>
            <a
              class="ripple light"
              [hidden]="pcodedDeviceType !== deviceType.desktop"
              id="desktop-collapse"
              href="javascript:"
              (click)="toggleSidebarInDesktop()"
            >
              <i class="feather" [ngClass]="sidebarToggleIcon" style="font-size: 25px"></i>
            </a>
          </div>
          <a *ngIf="clientLogo" class="logo light">
            <img class="client-logo" src="{{ clientLogo }}" alt="Iot Device Management Portal" />
          </a>
          <a (click)="reloadCurrentPage()" class="logo ripple light cursor-pointer">
            <img class="oee-logo" src="assets/images/df-logo.svg" alt="Digital Factory" />
          </a>
          <em class="fas fa-sync-alt refresh cursor-pointer" (click)="reloadCurrentPage()"></em>
          <a href="javascript:" class="mobile-options ripple light" (click)="toggleHeaderNavRight()">
            <i class="feather icon-more-horizontal"></i>
          </a>
        </div>
        <div class="navbar-container container-fluid display-inline">
          <ul [@mobileHeaderNavRight]="navRight" [ngClass]="navRight" class="nav-left">
            <li class="ripple light">
                  <a [routerLink]="['/home']"
                      [routerLinkActive]="['active-link']">
                    <i class="fas fa-home"></i> Home
                  </a>
            </li>
             <li class="ripple light">
                  <a [routerLink]="['/device-dashboard']"
                    [routerLinkActive]="['active-link']">
                    <i class="fas fa-cube"></i> Device Dashboard
                  </a>
            </li>
            <li class="ripple light">
                  <a [routerLink]="['/device-management']"
                    [routerLinkActive]="['active-link']">
                    <i class="fas fa-microchip"></i> Device Management
                  </a>
            </li>
             <li class="ripple light">
                  <a [routerLink]="['/device-last-message']"
                      [routerLinkActive]="['active-link']">
                    <i class="fas fa-envelope-open"></i> Device Last Messages
                  </a>
            </li>

         <li class="ripple light">
                  <a [routerLink]="['/device-command-schedule']"
                      [routerLinkActive]="['active-link']">
                    <i class="fas fa-history"></i> Device Command Schedule
                  </a>
            </li>


<!--             <li [hidden]="isTokenLoaded">-->
<!--              <a-->
<!--                [routerLink]="['/login']"-->
<!--                [routerLinkActive]="['active-link']"-->
<!--                class="ripple light nav-list mobile-nowrap mobile-nowrap-90"-->
<!--              >-->
<!--                <i class="fas fa-user"></i>-->
<!--                <span>Login</span>-->
<!--              </a>-->
<!--            </li>-->
          </ul>
          <ul [@mobileHeaderNavRight]="navRight" [ngClass]="navRight" class="nav-right">

        <li
              (clickOutside)="notificationOutsideClick('profile')"
              class="user-profile header-notification ripple light"
              (click)="toggleProfileNotification()"
            >
              <a class="mobile-nowrap" href="javascript:">
                <i class="fas fa-gears"> </i>
                <span> Settings</span>
                <i class="dropdown-icon feather icon-chevron-down"></i>
              </a>
              <ul
                [@notificationBottom]="profileNotification"
                class="router-dropdown show-notification profile-notification"
                [ngClass]="profileNotificationClass"
              >
                <li class="ripple">
                  <a [routerLink]="['/firmware-manager']"
                      [routerLinkActive]="['active-link']">
                    <i class="fas fa-files-o"></i> Firmware Manager
                  </a>
                </li>
                <li class="ripple">
                  <a [routerLink]="['/user-management']"
                      [routerLinkActive]="['active-link']">
                    <i class="fas fa-users"></i> User Management
                  </a>
                </li>

              </ul>
            </li>
            <li [hidden]="!isTokenLoaded">
              <a
                [routerLink]="['/logout']"
                class="ripple light nav-list mobile-nowrap mobile-nowrap-90"
              >
                <i class="fas fa-sign-out-alt"></i>
                <span>Logout</span>
              </a>
            </li>
            <li
              [hidden]="pcodedDeviceType !== deviceType.desktop"
              class="header-notification ripple light"
              appToggleFullScreen
            >
              <a href="javascript:">
                <em class="fas fa-expand-arrows-alt full-screen"></em>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="pcoded-main-container" [style.margin-top]="headerFixedMargin">
      <div class="pcoded-wrapper">
        <nav
          id="main_navbar"
          class="pcoded-navbar"
          [attr.navbar-theme]="navBarTheme"
          [attr.active-item-theme]="activeItemTheme"
          sub-item-theme="theme2"
          active-item-style="style0"
          [attr.pcoded-header-position]="pcodedHeaderPosition"
          [attr.pcoded-navbar-position]="pcodedSidebarPosition"
          [style.top]="headerFixedTop"
          [style.height]="sidebarFixedNavHeight"
          (mouseleave)="hoverOutsideSidebar()"
          [style.display]="sidebarDisplay"
        >
          <div class="pcoded-inner-navbar main-menu" appAccordion>
            <app-main-nav-bar [newMenuItems]="newMenuItems" [itemBorder]="itemBorder"></app-main-nav-bar>
          </div>
        </nav>
        <div class="pcoded-content">
          <page-header [pageHeader]="pageHeader" [hidden]="pageHeader.hideHeader"></page-header>
          <div [class.pcoded-inner-content]="!pageHeader?.isTabPage">
            <!-- Main-body start -->
            <div class="main-body">
              <div class="page-wrapper"  [class.page-wrapper-dashboard]="pageHeader?.hideHeader">
                <router-outlet>
                  <title></title>
                  <app-spinner></app-spinner>
                </router-outlet>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

